import Link from "next/link";
import { ArrowLeft } from "lucide-react";
import { Container } from "@/components/container";
import { LogoFull } from "@/components/logo";

/**
 * MinimalHeader (§6.1): logo + one quiet "Back to site" link. Removes exits on
 * conversion pages so the user completes the form.
 */
export function MinimalHeader() {
  return (
    <header className="sticky top-0 z-50 bg-background/85 backdrop-blur-md supports-[backdrop-filter]:bg-background/70">
      <Container className="flex h-16 items-center justify-between">
        <Link href="/" aria-label="Quto AI — home" className="shrink-0">
          <LogoFull />
        </Link>
        <Link
          href="/"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="size-4" strokeWidth={1.5} aria-hidden />
          Back to site
        </Link>
      </Container>
    </header>
  );
}
